// Frontend gating by role. The server-side gates (resolver role checks + the
// embed tokens core mints) are the enforcement; this module only decides what
// the UI shows. Decisions key off the primary role the backend derives and
// returns via WhoAmI — never off anything client-editable.
//
// User ADMINISTRATION (invite / roles / remove) is core's user-admin embed
// (/user-admin → containers/UserAdminView); the vocabulary below is what the
// shell needs to label and gate around it. See docs/user-roles.md.

import { Role } from "../services/__generated__/graphql";

//   Root      == ROOT      (the Atomic operator role — can manage users + View As)
//   Admin     == ADMIN     (the standard LMNT app user)
//   Data User == DATA_USER (restricted: Data tab only, read-only)
export const ROLE_LABELS: Record<string, string> = {
  [Role.Root]: "Root",
  [Role.Admin]: "Admin",
  [Role.DataUser]: "Data User",
  [Role.None]: "No role",
};

/** The Atomic operator role — full user management (roles, removal, View As). */
export const OPERATOR_ROLE: Role = Role.Root;

/** Roles that may open the User Admin page.
 *  Typed as strings because auth-context roles arrive untyped off the token. */
export const USER_ADMIN_ROLES: readonly string[] = [Role.Root, Role.Admin];

export function roleLabel(role: string | null | undefined): string {
  if (!role) return "—";
  return ROLE_LABELS[role] ?? role;
}

export const DATA_USER_ROLE = "DATA_USER";

export const isDataUser = (
  user: { role?: string | null } | null | undefined
): boolean => (user?.role ?? null) === DATA_USER_ROLE;

/** The only routes a data user may visit. The retired `/data-hub` tree
 *  (drill-downs still routable) deliberately doesn't match. */
export const isDataUserAllowedPath = (pathname: string): boolean =>
  pathname === "/data" ||
  pathname.startsWith("/data/") ||
  pathname === "/reporting" ||
  pathname.startsWith("/reporting/");
